"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWishlistSolid = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconWishlistSolid = function IconWishlistSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.659.638l-.115-.023A4.246 4.246 0 0122 4.51v15.538A4.127 4.127 0 0118.117 24H5.883A4.244 4.244 0 012 20.048V4.51A4.247 4.247 0 015.341.638a2.506 2.506 0 002.492 2.711h8.334A2.506 2.506 0 0018.659.638zm-4.992 16.664H7v1.675h6.667v-1.675zM17 13.953H7v1.675h10v-1.675zm0-3.348H7v1.674h10v-1.674zm0-3.35H7V8.93h10V7.256zM16.167 0c.46 0 .833.375.833.837a.835.835 0 01-.833.837H7.833A.835.835 0 017 .837C7 .375 7.373 0 7.833 0z",
    fillRule: "evenodd"
  }));
};
exports.IconWishlistSolid = IconWishlistSolid;